export const EQ_CLASS_NAMES = [
  'Bard',
  'Beastlord',
  'Berserker',
  'Cleric',
  'Druid',
  'Enchanter',
  'Magician',
  'Monk',
  'Necromancer',
  'Paladin',
  'Ranger',
  'Rogue',
  'Shadow Knight',
  'Shaman',
  'Warrior',
  'Wizard',
] as const;

export type EqClassName = (typeof EQ_CLASS_NAMES)[number];


export function classToSlug(className: string) {
  return className.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export function classFromSlug(slug: string | null | undefined): EqClassName | null {
  if (!slug) return null;
  const normalized = slug.trim().toLowerCase();
  return EQ_CLASS_NAMES.find((className) => classToSlug(className) === normalized) ?? null;
}
